<template>
  <div class="container-bg p-3">
    <div class="row">
      <div class="col-sm-12 col-md-12">
        <h3>Maak Eventtype</h3>

        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label for="">Titel</label>
              <input
                v-model="eventtype.title"
                type="text"
                class="form-control"
              />
            </div>
            <div class="form-group">
              <label for="">Adres</label>
              <input
                v-model="eventtype.settings.address"
                type="text"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-12 col-md-6">
            <form action="">
              <div class="container-bg pl-2 pr-2 pt-2">
                <div class="form-group pl-4">
                  <input
                    v-model="eventtype.recurrent"
                    @change="togglerecurrent"
                    class="form-check-input"
                    type="checkbox"
                    value=""
                    :id="'recurrent'"
                  />
                  <label class="form-check-label" :for="'recurrent'">
                    Herhalend
                  </label>
                </div>
                <div
                  style="margin-top: 26px"
                  v-if="eventtype.recurrent"
                  class="row"
                >
                  <div class="form-group col-6">
                    <label for="">Herhaling</label>
                    <select
                      v-model="
                        eventtype.settings.reoccurence_config.reoccurence_type
                      "
                      id=""
                      class="form-control"
                      @change="updateReoccurence()"
                    >
                      <option value="">-- Kies --</option>
                      <option
                        v-for="(obj, index) in config.reoccurrences"
                        :key="index"
                        :value="obj.value"
                      >
                        {{ obj.label }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-6">
                    <label for="">Dag</label>
                    <select
                      v-model="
                        eventtype.settings.reoccurence_config.reoccurence_day
                      "
                      class="form-control"
                      @change="updateReoccurence()"
                    >
                      <option value="">-- Kies --</option>
                      <option value="1">Maandag</option>
                      <option value="2">Dinsdag</option>
                      <option value="3">Woensdag</option>
                      <option value="4">Donderdag</option>
                      <option value="5">Vrijdag</option>
                      <option value="6">Zaterdag</option>
                      <option value="7">Zondag</option>
                    </select>
                  </div>
                  <div class="form-group col-6">
                    <label for="">Starttijd</label>
                    <input
                      v-model="eventtype.settings.reoccurence_config.start_time"
                      type="time"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-6">
                    <label for="">Eindtijd</label>
                    <input
                      v-model="eventtype.settings.reoccurence_config.end_time"
                      type="time"
                      class="form-control"
                    />
                  </div>

                  <div class="form-group col-6">
                    <label for="">Begindatum</label>
                    <input
                      @change="
                        updateEndDate(
                          eventtype.settings.reoccurence_config.start_date
                        )
                      "
                      v-model="eventtype.settings.reoccurence_config.start_date"
                      type="date"
                      id="kkkk"
                      class="form-control"
                    />
                  </div>
                  <div class="form-group col-6">
                    <label for="">Einddatum</label>
                    <input
                      v-model="eventtype.settings.reoccurence_config.end_date"
                      type="date"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group col-12" style="margin-left: 25px">
                <input
                  v-model="eventtype.absense"
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  :id="'absense'"
                />
                <label class="form-check-label" :for="'absense'">
                  Absentie
                </label>
              </div>

              <div class="col-12 mb-4 pl-5" v-if="eventtype.absense">
                <label for="">Verantwoordelijk</label>
                <Select2
                  v-model="eventtype.settings.absence_user_id"
                  :options="users"
                ></Select2>

                <div class="mt-1">
                  <input
                    v-model="eventtype.settings.send_absense_email"
                    type="checkbox"
                    id="sendAbsenseUser"
                  />
                  &nbsp;
                  <label for="sendAbsenseUser"> Stuur absentie email</label>
                </div>
              </div>

              <div class="form-group col-12" style="margin-left: 25px">
                <input
                  v-model="eventtype.settings.absence_by_attendees"
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  :id="'absense_deelnemers'"
                />
                <label class="form-check-label" :for="'absense_deelnemers'">
                  Absentie door deelnemers
                </label>
              </div>
              <div class="form-group col-12" style="margin-left: 25px">
                <input
                  v-model="eventtype.settings.default_attend"
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  :id="'default_attend'"
                />
                <label class="form-check-label" :for="'default_attend'">
                  Standaard aanwezig
                </label>
              </div>
              <div class="col-12 form-group mt-2">
                <label for="">Informatiegroepen</label>
                <Multiselect
                  searchable
                  mode="tags"
                  v-model="eventtype.settings.reoccurence_config.itemgroups"
                  :options="itemgroups"
                />
                <!-- <Select2
                  @change="pickItemgroup()"
                  v-model="selected_itemgroup"
                  :options="itemgroups"
                ></Select2> -->

                <div class="">
                  <ol>
                    <li
                      v-for="(group, index) in selected_itemgroups"
                      :key="index"
                    >
                      {{ group.text }}
                    </li>
                  </ol>
                </div>
              </div>
            </form>
          </div>
          <div class="col-12 col-md-6">
            <div class="row">
              <div class="col-md-12 col-12 pt-4 pb-4 container-bg">
                <label for="">Instellingen</label>
                <div class="form-group">
                  <label for="">Kies kleur</label><br />
                  <input v-model="eventtype.settings.color" type="color" />
                </div>
              </div>
              <div class="col-12 pt-4 pb-4 container-bg">
                <label for="">Selecteer commissies</label>
                <Multiselect
                  searchable
                  mode="tags"
                  v-model="selected_committees"
                  :options="committees"
                />
                <!-- <div class="col-md-10 custom-scrollbar" style="height: 200px">
                  <div
                    v-for="(comt, index) in committees"
                    :key="index"
                    class="form-check"
                  >
                    <input
                      v-model="comt.selected"
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      :id="'check_' + comt.id"
                    />
                    <label class="form-check-label" :for="'check_' + comt.id">
                      {{ comt.title }}
                    </label>
                  </div>
                </div> -->
              </div>
              <div class="col-12 pt-4 pb-4 container-bg">
                <label for="">Selecteer Groepen</label>
                <Multiselect
                  searchable
                  mode="tags"
                  v-model="selected_groups"
                  :options="groups"
                />

                <!-- <div class="row">
                  <div class="col-md-10 custom-scrollbar" style="height: 200px">
                    <div
                      v-for="(comt, index) in groups"
                      :key="index"
                      class="form-check"
                    >
                      <input
                        v-model="comt.selected"
                        class="form-check-input"
                        type="checkbox"
                        value=""
                        :id="'check2_' + comt.id"
                      />
                      <label
                        class="form-check-label"
                        :for="'check2_' + comt.id"
                      >
                        {{ comt.title }}
                      </label>
                    </div>
                  </div>
                </div> -->
              </div>
              <div class="col-12 pt-4 pb-4 container-bg">
                <label for="">Selecteer Leden</label>
                <Multiselect
                  searchable
                  mode="tags"
                  v-model="selected_users"
                  :options="users"
                />

                <div class="row p-0 m-0 mt-2">
                  <div class="form-group col-4 mb-1 mt-1" style="">
                    <input
                      v-model="
                        eventtype.settings.reoccurence_config.association
                      "
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      :id="'association'"
                    />
                    <label class="form-check-label" :for="'association'">
                      Vereniging
                    </label>
                  </div>
                  <div class="form-group col-4 mb-1 mt-1" style="">
                    <input
                      v-model="eventtype.settings.reoccurence_config.group"
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      :id="'group'"
                    />
                    <label class="form-check-label" :for="'group'">
                      Groepen
                    </label>
                  </div>
                  <div class="form-group col-4 mb-1 mt-1" style="">
                    <input
                      v-model="eventtype.settings.reoccurence_config.committee"
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      :id="'committee'"
                    />
                    <label class="form-check-label" :for="'committee'">
                      Commissies
                    </label>
                  </div>
                  <div class="form-group col-4 mb-1 mt-1" style="">
                    <input
                      v-model="eventtype.settings.reoccurence_config.public"
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      :id="'public'"
                    />
                    <label class="form-check-label" :for="'public'">
                      Publiek
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 mt-3">
            <p class="text-danger">{{ error_msg }}</p>
            <button
              @click="createEventype()"
              class="btn text-white btn-dark active item tab-styling"
            >
              <span v-if="!creating">Aanmaken</span>
              <span v-else>Aan het opslaan...</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      committees: [],
      test: "test",
      groups: [],
      itemgroups: [],
      eventtype: {
        title: "",
        settings: {
          color: "#4192D9",
          absence_user_id: null,
          send_absense_email: false,
          default_attend: false,
          reoccurence_config: {
            reoccurence: "",
            reoccurence_type: "",
            reoccurence_day: "",
            start_time: "",
            end_time: "",
            start_date: "2021-03-15",
            end_date: "2021-07-17",
            association: false,
            group: false,
            committee: false,
            itemgroups: [],
          },
          absence_by_attendees: false,
          address: "",
        },
        absense: false,
        recurrent: false,
      },
      default_config: {
        reoccurence: "",
        start_time: "",
        end_time: "",
        absense: false,
        association: false,
        group: false,
        committee: false,
        itemgroups: [],
      },
      selected_itemgroup: "",
      selected_committees: [],
      selected_groups: [],
      selected_users: [],
      creating: false,
      config: {},
      error_msg: "",
      users: [],
    };
  },
  computed: {
    selected_itemgroups() {
      return this.itemgroups.filter((d) =>
        this.eventtype.settings.reoccurence_config.itemgroups.find(
          (e) => e == d.id
        )
      );
    },
  },
  methods: {
    updateEndDate(startDate) {
      if (!startDate) return;

      var date = new Date(startDate);
      date.setFullYear(date.getFullYear() + 1);
      date.setDate(date.getDate() - 1);

      var eventtype = this.eventtype.settings.reoccurence_config;

      this.eventtype.settings.reoccurence_config = {
        ...eventtype,
        end_date: date.toISOString().slice(0, 10),
      };
    },
    togglerecurrent() {
      console.log(this.eventtype.recurrent);
      if (this.eventtype.id && !this.eventtype.recurrent) {
        if (
          !window.confirm(
            "Are you sure you want to remove reoccuring on this eventtype?"
          )
        ) {
          this.eventtype.recurrent = true;
        }
        return false;
      }

      if (!this.eventtype.recurrent) {
        this.eventtype.settings.reoccurence_config = { ...this.default_config };
      }
    },
    updateReoccurence() {
      // TODO add dependency to settings days property
      if (
        this.eventtype.settings.reoccurence_config.reoccurence_type == "e_year"
      ) {
        this.eventtype.settings.reoccurence_config.reoccurence_day = "";
      }

      this.eventtype.settings.reoccurence_config.reoccurence =
        this.eventtype.settings.reoccurence_config.reoccurence_type +
        this.eventtype.settings.reoccurence_config.reoccurence_day;
    },
    pickItemgroup() {
      this.eventtype.settings.reoccurence_config.itemgroups.push(
        this.selected_itemgroup
      );
    },
    validateReoccurence() {
      var data = this.eventtype.settings;
      if (data.reoccurence_config.reoccurence.trim().length == 0) {
        this.error_msg = "Select a reoccurence interval";
        return false;
      }
      if (data.reoccurence_config.start_time.trim().length == 0) {
        this.error_msg = "Pick a start date";
        return false;
      }
      if (data.reoccurence_config.end_time.trim().length == 0) {
        this.error_msg = "Pick an ending date";
        return false;
      }
      return true;
    },
    createEventype() {
      // if (this.creating) {
      //   return false;
      // }
      // if (this.eventtype.title.trim().length == 0) {
      //   return false;
      // }

      // if (!this.validateReoccurence()) return false;

      //this.creating = true;

      this.$store
        .dispatch(this.eventtype.id ? "put" : "post", {
          details: {
            ...this.eventtype,
            committees: this.selected_committees,
            groups: this.selected_groups,
            users: this.selected_users,
            itemgroups: this.eventtype.settings.itemgroups,
          },
          endpoint: this.eventtype.id
            ? "api/v1/eventtypes/" + this.eventtype.id
            : "api/v1/eventtypes",
        })
        .then(() => {
          this.creating = false;
          // this.$router.push({path:'/settings/edit/eventtype/'+data.data.data.id})
          this.$router.push({ path: "/settings/list/eventtypes" });
        })
        .catch((error) => {
          console.log(error);
          this.creating = false;
        });
    },
    groupsList(data, groups, prefix = "") {
      data.forEach((el) => {
        groups.push({
          value: el.id,
          label: prefix + el.title,
          disabled: false,
        });

        if (el.children?.length > 0) {
          this.groupsList(el.children, groups, `${prefix + el.title} - `);
        }
      });

      return groups;
    },
  },
  async created() {
    this.eventtype.settings.reoccurence_config = { ...this.default_config };
    this.config = this.$store.state.eventtype_config;
    await this.$store
      .dispatch("get", "api/v1/itemgroups")
      .then(({ data }) => {
        let groups = this.groupsList(data.data, [], "");
        this.itemgroups = groups.sort((a, b) => a.label.localeCompare(b.label));
      })
      .catch((error) => {
        console.log(error);
      });

    await this.$store
      .dispatch("get", "api/v1/committees/parent_id/3")
      .then(({ data }) => {
        data.data.forEach((c) => {
          this.committees.push({
            value: c.id,
            label: c.title,
          });
        });
        /* this.committees.push() = data.data.data.map((d) => {
          d.selected = false;
          return d;
        }); */
      })
      .catch((error) => {
        if (error.request.status == 422) {
          var response = JSON.parse(error.request.response).errors;
          for (var err in response) {
            this.error = response[err][0];
          }
        }
      });

    await this.$store
      .dispatch("get", "/api/v1/users")
      .then((data) => {
        console.log(data);
        this.users = data.data.data.map((u) => {
          return {
            label: `${u.firstname} ${u.lastname}`,
            value: u.id,
            text: `${u.firstname} ${u.lastname}`,
            id: u.id,
          };
        });
      })
      .catch((error) => {
        console.log(error.request);
      });

    await this.$store
      .dispatch("get", "api/v1/committees/parent_id/2")
      .then(({ data }) => {
        data.data.forEach((c) => {
          this.groups.push({
            value: c.id,
            label: c.title,
          });
        });
      })
      .catch((error) => {
        if (error.request.status == 422) {
          var response = JSON.parse(error.request.response).errors;
          for (var err in response) {
            this.error = response[err][0];
          }
        }
      });

    if (this.$route.params.id) {
      this.$store
        .dispatch("get", "api/v1/eventtypes/" + this.$route.params.id)
        .then((data) => {
          console.log(data);
          let eventtype = data.data.data;
          if (eventtype.settings) {
            eventtype.settings = JSON.parse(eventtype.settings);
            if (eventtype.settings.reoccurence_config) {
              this.eventtype.recurrent = true;
            } else {
              eventtype.settings.reoccurence_config = {
                reoccurence: "",
                reoccurence_type: "",
                reoccurence_day: "",
                start_time: "",
                end_time: "",
                start_date: "2021-03-15",
                end_date: "2021-07-17",
                association: false,
                group: false,
                committee: false,
                itemgroups: [],
              };
            }
          }

          this.selected_committees = eventtype.committees.map((c) => {
            return c.id;
          });
          this.selected_groups = eventtype.groups.map((g) => {
            return g.id;
          });

          this.selected_users = eventtype.users.map((g) => {
            return g.id;
          });

          this.eventtype = { ...eventtype };
          this.eventtype.recurrent = eventtype.recurrent;
        })
        .catch((error) => {
          if (error.request.status == 422) {
            var response = JSON.parse(error.request.response).errors;
            for (var err in response) {
              this.error = response[err][0];
            }
          }
        });
    }
  },
};
</script>

<style scoped>
select.form-control {
  background: #87bce8;
  color: #e0e0e0;
}
</style>
